import { Link } from 'react-router-dom'
import { CheckCircle, Package, Truck, CreditCard } from 'lucide-react'

const OrderSuccess = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-lg p-8 text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-10 h-10 text-green-600" />
          </div>
          
          {/* Success Message */}
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Order Placed Successfully!
          </h1>
          <p className="text-gray-600 mb-6">
            Thank you for your purchase. Your order has been confirmed and will be processed shortly.
          </p>
          
          {/* Order Details */}
          <div className="bg-gray-50 rounded-lg p-4 mb-6">
            <div className="flex items-center justify-between mb-2">
              <span className="text-sm text-gray-600">Order Number:</span>
              <span className="font-semibold text-gray-900">ORD-{Date.now()}</span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm text-gray-600">Estimated Delivery:</span>
              <span className="font-semibold text-gray-900">
                {new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toLocaleDateString()}
              </span>
            </div>
          </div>
          
          {/* Next Steps */}
          <div className="space-y-3 mb-6">
            <div className="flex items-center text-left">
              <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                <CreditCard className="w-4 h-4 text-blue-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Payment Confirmed</p>
                <p className="text-xs text-gray-600">Your payment has been processed</p>
              </div>
            </div>
            
            <div className="flex items-center text-left">
              <div className="w-8 h-8 bg-yellow-100 rounded-full flex items-center justify-center mr-3">
                <Package className="w-4 h-4 text-yellow-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Order Processing</p>
                <p className="text-xs text-gray-600">We're preparing your items</p>
              </div>
            </div>
            
            <div className="flex items-center text-left">
              <div className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center mr-3">
                <Truck className="w-4 h-4 text-gray-600" />
              </div>
              <div>
                <p className="text-sm font-medium text-gray-900">Shipping Soon</p>
                <p className="text-xs text-gray-600">You'll receive tracking info</p>
              </div>
            </div>
          </div>
          
          {/* Action Buttons */}
          <div className="space-y-3">
            <Link
              to="/products"
              className="btn btn-primary w-full py-3"
            >
              Continue Shopping
            </Link>
            <Link
              to="/"
              className="btn btn-outline w-full py-3"
            >
              Back to Home
            </Link>
          </div>
          
          {/* Contact Info */}
          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-600">
              Questions about your order? Contact us at{' '}
              <a href="mailto:support@electronicsstore.com" className="text-primary-600 hover:text-primary-700">
                support@electronicsstore.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrderSuccess